import '../../styles/video-js.css'
import React from 'react'
import Box from '../../atoms/Box'
import styled from 'styled-components'
import {media} from '../../utils/media'
import {Button} from '../../atoms/Button'
import {Instance, types} from 'mobx-state-tree'
import {observable} from 'mobx'
import {observer} from 'mobx-react'
import {RouteComponentProps, withRouter} from 'react-router'
import {env} from '../../utils/env'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? '_ES' : ''

let myPlayer: any

let cloudinaryUrlPNG: string
let cloudinaryUrlJPG: string
if (window.innerWidth < 400) {
  cloudinaryUrlPNG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/w_600,c_scale,f_png/'
  cloudinaryUrlJPG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/w_800,c_scale,f_jpg/'
} else {
  cloudinaryUrlPNG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/f_png/'
  cloudinaryUrlJPG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/f_jpg/'
}

(window as any).getPlayer = () => myPlayer

const KidsGamesModal = types.model(
  {
    maskGameVideo: types.string,
    sleepGameVideo: types.string,
    wakeUpGameVideo: types.string,
    buildGameVideo: types.string,
    buildGameVideoPablo: types.string,
    selectedGameVideo: types.string,
    selectedGame: types.string,
    width: types.number,
    height: types.number,
    videoFinished: false,
  })
  .views(self => ({
    get videoUrl() {
      return self[self.selectedGameVideo]
    },
    get posterUrl() {
      switch (self.selectedGameVideo) {
        case 'maskGameVideo': return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/Game2-Intro-preview%402x.jpg`
        case 'sleepGameVideo': return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/Game1-Intro-preview%402x.jpg`
        case 'wakeUpGameVideo': return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/Game3-Intro-preview%402x.jpg`
        case 'buildGameVideo': return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/Game4-anna-intro%402x.jpg`
        case 'buildGameVideoPablo': return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/Game4-pablo-intro-preview%402x.jpg`
      
        default: return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/Game2-Intro-preview%402x.jpg`
      }
    },
    get finished() {
      return self.videoFinished
    },
  }))
  .actions(self => ({
    setVideoFinished(finish: boolean) {
      self.videoFinished = finish
    },
    changeSize(width: number, height: number) {
      self.width = width
      self.height = height
    },
  }))

interface IProps extends RouteComponentProps {
  selectedGameVideo: string,
  title: string,
}

@observer
class KidsGamesViewBase extends React.Component<IProps> {
  @observable public store: Instance<typeof KidsGamesModal>
  public player: any

  public constructor(props: any) {
    super(props)
    this.handleWindowSize = this.handleWindowSize.bind(this)
    const {selectedGameVideo, title} = this.props
    const width = window.innerWidth > 390 ? Math.min(window.innerWidth - 200, 800) : window.innerWidth
    const height = width / 2.1
    let selectedGame = (title === 'Mask game' ||  title === 'Juego de Mascarilla') ? 'mask-game' :
      ((title === 'Sleep room game' || title === 'Juego del Cuarto de Dormir') ? 'sleep-room' : 'wake-up-room')
    if(title === 'Juego de Construir un Cuarto'){
      selectedGame = 'silly-juice-game'
    }
    this.store = KidsGamesModal.create({
      maskGameVideo: `https://s3-us-west-1.amazonaws.com/uci-images/video/kids/Game2-Intro${lang}.mp4`,
      sleepGameVideo: `https://s3-us-west-1.amazonaws.com/uci-images/video/kids/Game1-Intro${lang}.mp4`,
      wakeUpGameVideo: `https://s3-us-west-1.amazonaws.com/uci-images/video/kids/Game3-Intro${lang}.mp4`,
      buildGameVideo: `https://s3-us-west-1.amazonaws.com/uci-images/video/kids/Game4-anna-intro.mp4`,
      buildGameVideoPablo: `https://s3-us-west-1.amazonaws.com/uci-images/video/kids/Game4-pablo-intro.mp4`,
      
      width,
      height,
      selectedGameVideo,
      selectedGame,
    })
  }

  public componentDidMount() {
    if (!this.store.finished) {
      myPlayer = (window as any).videojs((window as any).player)

      let currentTime = 0

      myPlayer.on('seeking', () => {
        if (currentTime < myPlayer.currentTime()) {
          myPlayer.currentTime(currentTime)
        }
      })

      myPlayer.on('seeked', () => {
        if (currentTime < myPlayer.currentTime()) {
          myPlayer.currentTime(currentTime)
        }
      })

      setInterval(() => {
        if (!myPlayer.paused()) {
          currentTime = myPlayer.currentTime()
        }
      }, 1000)

      myPlayer.on('play', () => {
        (window as any).trackVideo(
          window.location.pathname,
          this.props.title,
          myPlayer.duration(),
          myPlayer.currentTime(),
          'play',
        )
      })
      myPlayer.on('pause', () => {
        (window as any).trackVideo(
          window.location.pathname,
          this.props.title,
          myPlayer.duration(),
          myPlayer.currentTime(),
          'pause',
        )
      })
      myPlayer.on('ended', async () => {
        (window as any).trackVideo(
          window.location.pathname,
          this.props.title,
          myPlayer.duration(),
          myPlayer.currentTime(),
          'ended',
        )
        this.videoFinished()
      })
    }
  }

  public componentWillMount(): void {
    window.addEventListener('resize', this.handleWindowSize)
  }

  public componentWillUnmount(): void {
    window.removeEventListener('resize', this.handleWindowSize)
  }

  public handleWindowSize() {
    const width = window.innerWidth > 390 ? Math.min(window.innerWidth - 200, 800) : window.innerWidth
    const height = width / 2.1
    this.store.changeSize(width, height)
  }

  public videoFinished() {
    this.store.setVideoFinished(true)
  }

  public render() {
    const {title} = this.props
    const gameUrl = env.REACT_APP_GAME_HOST + '/' + this.store.selectedGame + (process.env.REACT_APP_LANGUAGE === 'es' ? '-es/' : '/')
    return (
        <div>
          <H1>{title}</H1>
          <Box h={20}/>
          {!this.store.finished &&
          <Container>
            <Video
              className="video-js "
              preload="auto"
              autoPlay={true}
              controls={true}
              width={this.store.width}
              height={this.store.height}
              style={{alignSelf: 'center'}}
              poster={this.store.posterUrl}
              ref={(player: any) => (window as any).player = player}
              id="my-video">
              <source
                src={this.store.videoUrl} type="video/mp4"/>
            </Video>
          </Container>}
          {this.store.finished &&
          <Container>
            <Iframe src={gameUrl} frameBorder={0} allow="autoplay" />
          </Container>}
          <Button color={'purple'} onClick={() => window.history.back()}>{lang === '_ES' ? 'Volver' : 'Back'}</Button>
        </div>
    )
  }
}

export const KidsGamesView = withRouter(KidsGamesViewBase)

const Video = styled.video<{ id?: string; class?: string; controls?: boolean }>`
  margin: 30px 0px;
`

const Iframe = styled.iframe`
  display: flex;
  justify-content: flex-start;
  position: relative;
  border-radius: 20px;
  width: 816px;
  height: 476px;
  margin: 30px 0px;
  @media only screen and (max-width: 299px) and (orientation: portrait) {
    transform: scale(0.3);
  }
  @media only screen and (min-width: 300px) and (orientation: portrait) {
    transform: scale(0.35);
  }
  @media only screen and (min-width: 360px) and (orientation: portrait) {
    transform: scale(0.4);
  }
  @media only screen and (min-width: 400px) and (orientation: portrait) {
    transform: scale(0.5);
  }
  @media only screen and (min-width: 500px) and (orientation: portrait) {
    transform: scale(0.6);
  }
  @media only screen and (min-width: 600px) and (orientation: portrait) {
    transform: scale(0.7);
  }
  @media only screen and (min-width: 821px) and (orientation: portrait) {
    width: 816px;
    height: 476px;
  }

  @media only screen and (min-height: 300px) and (orientation: landscape) {
    transform: scale(0.5);
  }
  @media only screen and (min-height: 350px) and (orientation: landscape) {
    transform: scale(0.6);
  }
  @media only screen and (min-height: 400px) and (orientation: landscape) {
    transform: scale(0.7);
  }
  @media only screen and (min-height: 500px) and (orientation: landscape) {
    width: 816px;
    height: 476px;
    transform: none;
  }
`

const H1 = styled.div`
  font-family: Nunito;
  font-weight: 900;
  font-size: 1.6rem;
  margin-top: 30px;
  color: white;
  text-align: center;

  ${media.tablet`
    font-size: 2.5rem;
    margin-top: 0px;
  `}
`

const Container = styled.div`
  display: grid;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/organisms/KidsGame/KidsGameView.tsx